import { memo } from 'react'
import OfferListImage from 'assets/images/autoscout24/bank_offers_phone.png'
import { Container } from '@mui/material'
import { useTheme } from '@mui/styles'
import { useUrlParams } from 'stores/utils/hooks/useUrlParams'

const OffersImage = () => {
  const urlParams = useUrlParams()
  const theme = useTheme()

  if (urlParams.asTestId !== 'offers') {
    return null
  }

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(-1),
        marginBottom: theme.spacing(4)
      }}
    >
      <img
        src={OfferListImage}
        alt="Autoscout24 offers"
        style={{ maxWidth: 320 }}
      />
    </Container>
  )
}

export default memo(OffersImage)
